import { z } from 'zod';
import { revenueCatPackage } from './RevenueCatPackage';

export const revenueCatOffering = z.object({
  created_at: z.number(),
  display_name: z.string(),
  id: z.string(),
  is_current: z.boolean(),
  lookup_key: z.string(),
  metadata: z.record(z.string(), z.unknown()),
  object: z.literal('offering'),
  project_id: z.string(),
  packages: z
    .object({
      object: z.literal('list'),
      items: z.array(revenueCatPackage),
      next_page: z.string().nullish(),
      url: z.string(),
    })
    .nullish(),
});

export type RevenueCatOffering = z.infer<typeof revenueCatOffering>;
